import axiosInstance from "./authentication/axiosInstance";

export const dashboardService = {
    getJobsByStatusForDashboard: async (status, search = "") => {
        const response = await axiosInstance.get(`/dashboard/jobsByStatusForDashboard`, {
            params: { status, search },
        });
        return response.data;
    },

    getJobStatusCountsForDashboard: async () => {
        const response = await axiosInstance.get(`/dashboard/jobStatusCountsForDashboard`);
        return response.data;
    },

    getJobEndDateCountsForDashboard: async () => {
        const response = await axiosInstance.get(`/dashboard/jobEndDateCountsForDashboard`);
        return response.data;
    },

    getJobsByEndDateForDashboard: async (period, search = "") => {
        const response = await axiosInstance.get(`/dashboard/jobsByEndDateForDashboard`, {
            params: { period, search },
        });
        return response.data;
    },

    // getJobHoursSummaryForDashboard: async () => {
    //     const response = await axiosInstance.get(`/dashboard/jobHoursSummaryForDashboard`);
    //     return response.data;
    // },

    getJobHoursSummaryForDashboard: async ({ userId, teamId, clientCategory, months, year }) => {
        const response = await axiosInstance.get(`/dashboard/jobHoursSummaryForDashboard`, {
            params: {
                userId,
                teamId,
                clientCategory,
                months,
                year,
            },
            paramsSerializer: params => {
                const query = [];

                for (const [key, value] of Object.entries(params)) {
                    if (value === null || value === undefined || value === "") continue;

                    if (Array.isArray(value)) {
                        value.forEach(v => query.push(`${key}=${v}`));
                    } else {
                        query.push(`${key}=${value}`);
                    }
                }

                return query.join("&");
            }
        });
        return response.data;
    },

    // getJobsByCompletionStatusForDashboard: async (status) => {
    //     const response = await axiosInstance.get(`/dashboard/jobsByCompletionStatusForDashboard`, {
    //         params: { status },
    //     });
    //     return response.data;
    // },

    getJobsByCompletionStatusForDashboard: async (userId, teamId, clientCategory, months, year, completed, search = "") => {
        const response = await axiosInstance.get(`/dashboard/jobsByCompletionStatusForDashboard`, {
            params: {
                userId,
                teamId,
                clientCategory,
                months,
                year,
                completed,
                search
            },
            paramsSerializer: params => {
                const query = [];

                for (const [key, value] of Object.entries(params)) {
                    if (value === null || value === undefined || value === "") continue;

                    if (Array.isArray(value)) {
                        value.forEach(v => query.push(`${key}=${v}`));
                    } else {
                        query.push(`${key}=${value}`);
                    }
                }

                return query.join("&");
            }
        });
        return response.data;
    },

    getJobGroupCountsForDashboard: async () => {
        const response = await axiosInstance.get(`/dashboard/jobGroupCountsForDashboard`);
        return response.data;
    },

    getJobsByGroupForDashboard: async (group, value, search = "") => {
        const response = await axiosInstance.get(`/dashboard/jobsByGroupForDashboard`, {
            params: { group, value, search }
        });
        return response.data;
    },

    getActiveTasksSummaryForDashboard: async () => {
        const response = await axiosInstance.get(`/dashboard/activeTasksSummaryForDashboard`);
        return response.data;
    },

    getActiveTasksDetailsForDashboard: async (category) => {
        const response = await axiosInstance.get(`/dashboard/activeTasksDetailsForDashboard`, {
            params: { category },
        });
        return response.data;
    },

    getMonthlyBreaksForDashboard: async (userId, month, year) => {
        const params = [];
        if (month != null) params.push(`month=${month}`);
        if (year != null) params.push(`year=${year}`);
        const query = params.length ? `?${params.join("&")}` : "";
        const response = await axiosInstance.get(`/dashboard/monthlyBreaksForDashboard/${userId}${query}`);
        return response.data;
    },

    getUserTargetAchievement: async (teamLeaderId = null, month, year) => {
        const response = await axiosInstance.get(`/dashboard/userTargetAchieveHours`, {
            params: {
                teamLeaderId: teamLeaderId,
                month: month,
                year: year
            },
        });
        return response.data;
    },

};